<template>
    <el-container type="flex" class="main_container">
    <base-header>{{clientInfo.nickname}}的接龙详情</base-header>
    <el-main>
      <el-table :data="group_buy_info_list" v-loading="loading" height="100%" >
         <el-table-column label="创建时间" :width="140">
          <template v-slot="scope">
            <div>{{scope.row.create_time}}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片" :width="140" :align="center">
          <template v-slot="scope">
            <div style="width:120px; height: 120px">
              <img :src="scope.row.good_pic" style="width:100%; height:100%" alt=""/>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in table_client_id"
          :key="column.index"
          :prop="column.table_prop"
          :label="column.table_label"
          :align="column.table_align || 'center'"
          :width="column.table_width"
        ></el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="total_count"
        :page-size="pagesize"
        :current-page="page"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </el-footer>
  </el-container>
</template>
<script>
import pageMixin from '../../../mixins/page'
export default {
  name: 'GroupBuy',
  mixins: [pageMixin],
  data () {
    return {
      ClientBuyURL: this.getDomain() + 'bmclient/get_client_groupbuy_list', // 团长接龙详情
      group_buy_info_list: [],
      loading: true,
      clientInfo: {},
      client_id: parseInt(this.$route.params.client_id),
      table_client_id: [
        {
          table_prop: 'good_name',
          table_label: '商品名称'
        },
        {
          table_prop: 'sale_amount',
          table_label: '交易额(元)'
        },
        {
          table_prop: 'good_price',
          table_label: '单价(元)'
        },
        {
          table_prop: 'sale_count',
          table_label: '已售'
        },
        {
          table_prop: 'good_inventory',
          table_label: '库存'
        },
        {
          table_prop: 'status_msg',
          table_label: '接龙状态'
        },
        {
          table_prop: 'end_time_desc',
          table_label: '截止时间'
        }
      ]

    }
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        client_id: this.client_id
      }
      let handle = res => {
        this.total_count = res.data.content.total_count
        this.group_buy_info_list = res.data.content.data
        this.clientInfo = res.data.content.client_info
        this.group_buy_info_list.forEach(items => {
          items.good_price = items.good_price / 100
          items.sale_amount = items.sale_amount / 100
        })
      }
      let loadings = () => {
        this.loading = false
      }
      this.__axios(this.ClientBuyURL, params, handle, loadings)
    }
  },
  created () {
    this.getList()
  }
}
</script>
